import type { ReactNodeArray } from 'react';

const ProjectHasIssuesPanel = ({
  renderedIssues,
}: {
  renderedIssues: ReactNodeArray;
}) => (
  <div className="padded padded-small">
    <ul className="project-issues-list">
      {renderedIssues}
    </ul>
  </div>
);

export default ProjectHasIssuesPanel;
